import { memo, useContext, useEffect, useState } from "react";

import { useRouter } from "next/router";

import { Col, Collapse, Progress, Spin } from "antd";
import useTranslation from "next-translate/useTranslation";

import useCourse from "pages/[tenant]/courses/hooks/useCourse";

import Empty from "shared/components/atoms/EmptyData";
import Widget from "shared/components/templates/Widget";
import GlobalContext from "shared/providers/context/GlobalContext";

import SingleModule from "../SingleModule";
import {
  ColProgress,
  Container,
  Content,
  SectionTitle,
  SpinSection,
} from "./styles";

interface IPreviewContentCourseProps {
  course: any;
}
const PreviewContentCourse = ({ course }: IPreviewContentCourseProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { state } = useContext(GlobalContext);
  const course_slug = router?.query?.course_slug;
  const { getLessonsAndModules } = useCourse();

  const [modules, setModules] = useState([]);
  const [isLoadingLessons, setIsLoadingLessons] = useState(false);
  const tenantData = state.tenancy;

  useEffect(() => {
    const getCourseContent = async () => {
      setIsLoadingLessons(true);
      try {
        const modulesResponse = await getLessonsAndModules();
        setModules(modulesResponse);
      } catch (error) {
        console.log("error -->", error);
      }
      setIsLoadingLessons(false);
    };

    getCourseContent();
  }, [course_slug]);

  return (
    <Container>
      <Widget
        title={
          <>
            <SectionTitle>
              <span className="title">{t("common:lessons")}</span>

              {course.access_type === "free" && (
                <span className="section-title-badge">
                  {t("common:freeLessons")}
                </span>
              )}
            </SectionTitle>
          </>
        }
        transparentDarkDisabled
        styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
      >
        {isLoadingLessons ? (
          <SpinSection>
            <Spin />
          </SpinSection>
        ) : modules && modules?.length ? (
          <Content gutter={[8, 8]}>
            <Col span={24}>
              {course?.count_lessons && (
                <span>
                  {`${course?.count_lessons} ${t("common:lessons-m")}`}
                </span>
              )}
            </Col>

            <ColProgress span={24}>
              <Progress
                className="progress-line-course"
                strokeColor={{
                  "0%": tenantData?.settings["advanced-theme"]
                    ?.themeCourseProgressColor1,
                  "100%":
                    tenantData?.settings["advanced-theme"]
                      ?.themeCourseProgressColor2,
                }}
                percent={Math.floor(course?.complete_percentage || 0)}
              />
            </ColProgress>

            <Col span={24}>
              {course && course?.count_lessons && modules && (
                <>
                  <Collapse accordion>
                    {modules?.map(
                      (module, index) =>
                        module?.module?.status === "published" && (
                          <SingleModule
                            key={index}
                            module={module?.module}
                            lessons={module?.lessons}
                            course={course}
                          />
                        ),
                    )}
                  </Collapse>
                </>
              )}
            </Col>
          </Content>
        ) : (
          <Empty
            style={{
              marginTop: 20,
            }}
          />
        )}
      </Widget>
    </Container>
  );
};

export default memo(PreviewContentCourse);
